import type Pageable from 'models/Pageable';
import type {
  StatisticsOfDealerAgreementVO,
  StatisticsOfDealerAgreementVOModel,
} from 'models/vo/StatisticsOfDealerAgreementVO';
import { formattingToStatisticsOfDealerAgreementVOModel } from 'models/vo/StatisticsOfDealerAgreementVO';
import http from 'utils/http';
import API_FI from 'utils/http/api/financier';
import type { FinancierStatisticsOfDealerAgreementListRequest } from 'utils/http/api/financier/statistics-of-dealer-agreements/request';

export async function requestFiStatisticsOfDealerAgreementsList(
  pageNumber: number,
  rowCount: number,
  searchValue: FinancierStatisticsOfDealerAgreementListRequest,
): Promise<Pageable<StatisticsOfDealerAgreementVOModel[]>> {
  const response = await http.get<Pageable<StatisticsOfDealerAgreementVO[]>>({
    url: API_FI.STATISTICS_OF_DEALER_AGREEMENTS.STATISTICS_OF_DEALER_AGREEMENT_LIST,
    data: {
      pageNumber,
      rowCount,
      ...searchValue,
    },
  });
  const statisticsOfDealerAgreementList: StatisticsOfDealerAgreementVOModel[] = response.content.map(
    (data: StatisticsOfDealerAgreementVO) => formattingToStatisticsOfDealerAgreementVOModel(data),
  );
  const statisticsOfDealerAgreementPage: Pageable<StatisticsOfDealerAgreementVOModel[]> = {
    ...response,
    content: statisticsOfDealerAgreementList,
  };

  return statisticsOfDealerAgreementPage;
}
